import { TableLogisticPartners } from '../../components'

export const TabLogisticCarriers = () => {
  return (
    <div>
      <TableLogisticPartners externalFilter={{ type: 'transport_company' }} />
    </div>
  )
}
